import React from 'react'
import styles from "../components/laymanComp_css/LaymanPage10.module.css"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/theKaliKrishna.json";

export default function LaymanPage10_kalikrishna() {
  return (
    <>
       <Common_html BlockData={BlockData} />
    </>
  )
}